module.exports = __webpack_public_path__ + "img/Incognit_Cloud.02442965.png";